import { render, staticRenderFns } from "./ValidMember.vue?vue&type=template&id=33271287&scoped=true&"
import script from "./ValidMember.vue?vue&type=script&lang=js&"
export * from "./ValidMember.vue?vue&type=script&lang=js&"
import style0 from "./ValidMember.vue?vue&type=style&index=0&id=33271287&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33271287",
  null
  
)

export default component.exports